// extracted by mini-css-extract-plugin
export default {"vinni_img_container":"SuggestionsItem_vinni_img_container__gAnrv","suggestions_data_container":"SuggestionsItem_suggestions_data_container__OQwrC"};